
// 全局button的权限控制，根据餐单中返回的选项，显示或隐藏
// 注册一个全局自定义指令 `v-authBotton`
import { getSession } from '@/utils';

const btnAuthFun = (el, binding, vnode) => {
  // 当前有的所有的按钮权限
  // const navSecondList = JSON.parse(getSession('navSecondList'));
  const btnAuthList = JSON.parse(getSession('btnAuthList'));
  // let times = 0;
  // const timer = setInterval(() => {
  // console.log(binding, '按钮权限控制', binding.value, vnode.elm.disabled, btnAuthList.includes(binding.value));
  if (btnAuthList) {
    // clearInterval(timer);

    // 是按钮：则跟btnAuthList判断
    // 是内页，则跟navSecondList判断
    let strValue = binding.value;
    // 暂时注释，开发用 begin
    // if (strValue.indexOf('#') > -1) {
    //   if (btnAuthList.indexOf(strValue) === -1 && process.env.ENV_CONFIG !== 'dev') {
    //     // 本地环境不做权限控制
    // el.style.display = 'none';
    //   vnode.elm.hidden = true;
    //   vnode.elm.disabled = true;
    //   let className = vnode.elm.className + ' no-auth';
    //   vnode.elm.className = className;
    //   // el.parentNode.removeChild(el);
    //   el.remove();
    //   }
    // };
    // 暂时注释，开发用 end 到时候下面的要删掉

    // 开发阶段，测试环境也要用线上配置 begin
    if (!btnAuthList.includes(strValue)) {
      // 本地环境不做权限控制
      // console.log('没有权限的按钮：', strValue, btnAuthList.includes(strValue), el, binding, vnode, el.parentNode);
      el.style.display = 'none';
      vnode.elm.hidden = true;
      // vnode.elm.disabled = true;
      // let className = vnode.elm.className + ' no-auth';
      // vnode.elm.className = className;
      // el.parentNode.removeChild(el);
      // el.remove();
    } else {
      el.style.display = '';
      vnode.elm.hidden = false;
      // vnode.elm.disabled = false;
    }
    // else {
    //   if (navSecondList.indexOf(strValue) === -1) {
    //     // 本地环境不做权限控制
    //     el.style.display = 'none';
    //   }
    // };
    // 开发阶段，测试环境也要用线上配置 end

    //   } else if (times > 2000) {
    //     clearInterval(timer);
  }
  //   times += 100;
  // }, 100);
};

export default {
  // 当指令绑定到 HTML 元素上时触发.**只调用一次**
  // bind: (el, binding, vnode) => {
  // console.log('触发了bind： 333333333333333333333333333333333', binding.value);
  // },
  // 当绑定了指令的这个HTML元素插入到父元素上时触发(在这里父元素是 `div#app`)**.但不保证,父元素已经插入了 DOM 文档.**
  inserted: function(el, binding, vnode) {
    // console.log('触发了inserted： 333333333333333333333333333333333', binding.value);
    btnAuthFun(el, binding, vnode);
  },
  // 所在组件的`VNode`更新时调用.
  // update: (el, binding, vnode) => {
  // console.log('触发了update： 333333333333333333333333333333333', binding.value);
  // },
  // 指令所在组件的 VNode 及其子 VNode 全部更新后调用。
  componentUpdated: (el, binding, vnode) => {
    // console.log('触发了componentUpdated： 333333333333333333333333333333333', binding.value);
    btnAuthFun(el, binding, vnode);
  },
  // 只调用一次，指令与元素解绑时调用.
  unbind: function(el, binding, vnode) {
    // console.log('触发了unbind： 333333333333333333333333333333333', binding.value);
    btnAuthFun(el, binding, vnode);
  }
};
